// extracted by mini-css-extract-plugin
export default {"text":"userFullView_text__rFu7i","breadcrumb":"userFullView_breadcrumb__dBhzG"};